import script from "./DesignationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DesignationModal.vue?vue&type=script&setup=true&lang=js"

import "./DesignationModal.vue?vue&type=style&index=0&id=7a92e900&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a92e900"]])

export default __exports__